import { default as localeCustomizations } from './locales'
import { default as containerCustomizations } from './customizations'
import { IPartnerConfig } from '../../internal'

import logo from './assets/LinearLogo.png';
import scratchFront from './assets/linear-redeem-serial-number.png';
import scratchBack from './assets/linear-redeem-authentication-number.png';

// must export all of these for each partner. Empty if using defaults
const partnerCustomizations: IPartnerConfig = {
  assets: {
    logoOnBackground: logo,
    logoOnSecondary: logo,
    logoOnPrimary: logo,
    logoOnDark: logo,
    scratchCardFront: scratchFront,
    scratchCardBack: scratchBack
  },
  locales: localeCustomizations,
  containers: containerCustomizations,
}
export default partnerCustomizations;